import { useEffect, useState } from "react";

import { apiQuery } from "app/game-data/useQuery";

export const PREVIEW_GAME_QUERY = /* GraphQL */ `
  query PREVIEW_GAME($token: String) {
    spellcheck {
      content(token: $token) {
        token
        id
      }
    }
  }
`;

interface PreviewGameQueryResponseType {
  spellcheck: {
    content: {
      token: string;
      id: number;
    };
  };
}

export default function usePreviewGameId() {
  const [id, setId] = useState<number | undefined>();
  const urlParams = new URLSearchParams(window.location.search);
  const previewToken = urlParams.get("token");
  // Leaving this comment here because it's useful for testing
  // const previewToken = "gixFHV38DqrtFC6qKWfYTuLA";

  useEffect(() => {
    async function fetchPreviewGameId(token: string) {
      const response = await apiQuery<
        PreviewGameQueryResponseType,
        { token: string }
      >(PREVIEW_GAME_QUERY, {
        token,
      });

      if (response.data) {
        setId(response.data.spellcheck.content.id);
      }
    }

    if (previewToken) {
      fetchPreviewGameId(previewToken);
    }
  }, [previewToken]);

  return previewToken ? id : undefined;
}
